module.exports = __webpack_public_path__ + "img/LDSJ_STILL7.db49ca11.jpg";